import * as Yup from 'yup';

export const scheduleSchema = Yup.object().shape({
  description: Yup.string().required('Descrição é obrigatória.'),
});